import clsx from 'clsx';
import { useState } from 'react';
import ModalPortal from '../../../components/ModalPortal/ModalPortal';
import useIsMobile from '../../../hooks/useIsMobile/useIsMobile';
import Icon from '../Icon/Icon';
import ShareOption from '../ShareOption/ShareOption';
import { ShareColor, ShareProps } from './interfaces';
import styles from './Share.module.scss';
import ShareModal from './ShareModal/ShareModal';

const Share = ({
  url,
  text,
  title,
  label,
  headline = `Diesen Artikel teilen`,
  color,
  className,
  asNavItem,
}: ShareProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMobile = useIsMobile(1200);

  const onClick = async () => {
    if (navigator.share && isMobile) {
      navigator.share({
        title: title,
        text: text,
        url: url,
      });
    } else {
      if (!isModalOpen) {
        setIsModalOpen(true);
      }
    }
  };

  const linkLabel = label ? label : 'Teilen';

  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <div
        className={clsx(
          styles.base,
          {
            [styles.white]: color === ShareColor.White,
            [styles.darkGray]: color === ShareColor.DarkGray,
            [styles.black]: color === ShareColor.Black,
            [styles.navItem]: asNavItem,
          },
          className
        )}
        onClick={onClick}
      >
        <Icon
          variant={'action/share'}
          size="iconSize24"
          className={styles.icon}
        />
        <span className={styles.label}>{linkLabel}</span>
      </div>
      <ModalPortal
        id={`share-modal-${title}`}
        key={`share-modal-${title}`}
        disableCloseIcon
        onClose={handleClose}
        show={isModalOpen}
        mainLayerVisible={true}
        variant="shade"
      >
        <ShareModal handleClose={handleClose} headline={headline}>
          <ShareOption text={title} variant="linkCopy" />
          <ShareOption text={title} variant="eMail" />
          <ShareOption text={title} variant="facebook" />
          <ShareOption text={title} variant="twitter" />
          <ShareOption text={title} variant="xing" />
          <ShareOption text={title} variant="linkedIn" />
        </ShareModal>
      </ModalPortal>
    </>
  );
};

export default Share;
